import { Modal } from "melco-ui";
import { useTranslation } from "react-i18next";
import AcceptServiceTermsButton from "./AcceptServiceTermsButton";
import DeclineServiceTermsButton from "./DeclineServiceTermsButton";
import ServiceTermContent from "./ServiceTermContent";
import { find } from "lodash-es";
import { useAllProducts } from "../../hooks/useAllProduts";

type propsss = {
  productCode: string;
}
const ServiceTermModal: React.FC<propsss> = ({productCode}) => {

 // const productCode = productCodeVar;
 // const { productCode } = useParams<{ productCode: string }>();
  const { t } = useTranslation();
  const { products } = useAllProducts();
console.log(products)
console.log(productCode)
  // fetch product
  const product = find(products ?? [], (p) => p.code === productCode);
  if (!product) {
    return null;
  }

  const wrapClassName = `modal-terms-${productCode}`;

    return (
     <Modal
       title={`${t("dashboard.apps.legal_policy.title")} ${product.name}`}
     open={true}
      centered
      closable={false}
      width="80vw"
      wrapClassName={wrapClassName}
      footer={[
        <DeclineServiceTermsButton productCode={productCode} key="back" />,
        <AcceptServiceTermsButton key="submit" product={product} />,
      ]}
    >
     Terms Content will come here
      <ServiceTermContent productCode={productCode!} />
    </Modal>)
};

export default ServiceTermModal;
